import { render, staticRenderFns } from "./KeysMobile.vue?vue&type=template&id=650a6e1a&"
import script from "./KeysMobile.vue?vue&type=script&lang=ts&"
export * from "./KeysMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports